import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const surveyDetailsContentStyles = css`
  max-width: 60rem;
  @media ${BREAKPOINT_QUERIES.Mobile} {
    max-width: 100%;
  }
`;

export const surveyBannerStyles = css`
  height: 40rem;

  @media ${BREAKPOINT_QUERIES.Mobile} {
    height: 48.4rem;
  }
`;

export const surveyCompleteBannerStyles = css`
  height: 30rem;
`;
